import { toDisplayString as _toDisplayString, vShow as _vShow, withKeys as _withKeys, createElementVNode as _createElementVNode, withDirectives as _withDirectives, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, resolveDirective as _resolveDirective, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, vModelSelect as _vModelSelect, vModelText as _vModelText, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1712344e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "main-container" }
const _hoisted_2 = {
  key: 0,
  class: "detail-container"
}
const _hoisted_3 = {
  key: 0,
  class: "detail-row"
}
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "prompt" }, "URL:", -1))
const _hoisted_5 = { class: "ellipsize" }
const _hoisted_6 = {
  key: 1,
  class: "detail-row"
}
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "prompt" }, "Description:", -1))
const _hoisted_8 = { class: "detail-row" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "prompt" }, "Color:", -1))
const _hoisted_10 = { class: "detail-row" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "prompt" }, "Marker:", -1))
const _hoisted_12 = ["value"]
const _hoisted_13 = { class: "detail-row" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "prompt" }, "Size adjust:", -1))
const _hoisted_15 = { class: "flex-row" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_color_picker = _resolveComponent("color-picker")!
  const _component_Popper = _resolveComponent("Popper")!
  const _component_transition_expand = _resolveComponent("transition-expand")!
  const _directive_hide = _resolveDirective("hide")!

  return (_openBlock(), _createElementBlock("div", {
    id: "root-container",
    onMouseenter: _cache[9] || (_cache[9] = ($event: any) => (_ctx.hasFocus = true)),
    onMouseleave: _cache[10] || (_cache[10] = ($event: any) => (_ctx.hasFocus = false)),
    onFocus: _cache[11] || (_cache[11] = ($event: any) => (_ctx.hasFocus = true)),
    onBlur: _cache[12] || (_cache[12] = ($event: any) => (_ctx.hasFocus = false))
  }, [
    _createElementVNode("div", _hoisted_1, [
      _withDirectives(_createElementVNode("label", {
        focusable: "false",
        id: "name-label",
        class: "ellipsize",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.isSelected = !_ctx.isSelected)),
        onKeyup: _cache[1] || (_cache[1] = _withKeys(($event: any) => (_ctx.isSelected = !_ctx.isSelected), ["enter"]))
      }, _toDisplayString(_ctx.layer.name), 545), [
        [_vShow, !_ctx.editing]
      ]),
      _withDirectives(_createElementVNode("input", {
        class: "name-input",
        onBlur: _cache[2] || (_cache[2] = ($event: any) => (_ctx.editing = false))
      }, null, 544), [
        [_vShow, _ctx.editing]
      ]),
      (!_ctx.isLayerHips)
        ? _withDirectives((_openBlock(), _createBlock(_component_font_awesome_icon, {
            key: 0,
            onClick: _ctx.handleEditClick,
            class: _normalizeClass(['icon-button', { 'icon-active': _ctx.editing }]),
            icon: "pencil-alt"
          }, null, 8, ["onClick", "class"])), [
            [_directive_hide, !_ctx.hasFocus]
          ])
        : _createCommentVNode("", true),
      _withDirectives(_createVNode(_component_font_awesome_icon, {
        class: "icon-button",
        icon: _ctx.visible ? 'eye' : 'eye-slash',
        onClick: _ctx.handleToggle
      }, null, 8, ["icon", "onClick"]), [
        [_directive_hide, !_ctx.hasFocus]
      ]),
      _withDirectives(_createVNode(_component_font_awesome_icon, {
        class: "icon-button",
        icon: "times",
        onClick: _ctx.handleDelete
      }, null, 8, ["onClick"]), [
        [_directive_hide, !_ctx.hasFocus]
      ])
    ]),
    _createVNode(_component_transition_expand, null, {
      default: _withCtx(() => [
        (_ctx.isSelected)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              (_ctx.isLayerHips)
                ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                    _hoisted_4,
                    _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.layer.url), 1)
                  ]))
                : _createCommentVNode("", true),
              (_ctx.isLayerHips && _ctx.layer.description.length > 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                    _hoisted_7,
                    _createElementVNode("span", null, _toDisplayString(_ctx.layer.description), 1)
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_8, [
                _hoisted_9,
                _createVNode(_component_Popper, {
                  arrow: true,
                  placement: "right"
                }, {
                  content: _withCtx(() => [
                    _createVNode(_component_color_picker, {
                      class: "app-color-picker",
                      theme: "dark",
                      color: _ctx.colorString,
                      "colors-default": [],
                      onChangeColor: _ctx.handleColorChange
                    }, null, 8, ["color", "onChangeColor"])
                  ]),
                  default: _withCtx(() => [
                    _createVNode(_component_font_awesome_icon, {
                      icon: "circle",
                      size: "lg",
                      style: _normalizeStyle({
                color: `rgba(${_ctx.color.r}, ${_ctx.color.g}, ${_ctx.color.b}, ${_ctx.color.a})`,
              })
                    }, null, 8, ["style"])
                  ]),
                  _: 1
                })
              ]),
              _createElementVNode("div", _hoisted_10, [
                _hoisted_11,
                _withDirectives(_createElementVNode("select", {
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.plotType) = $event))
                }, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.uiPlotTypes, (pt) => {
                    return (_openBlock(), _createElementBlock("option", {
                      value: pt.wwt,
                      key: pt.desc
                    }, _toDisplayString(pt.desc), 9, _hoisted_12))
                  }), 128))
                ], 512), [
                  [_vModelSelect, _ctx.plotType]
                ])
              ]),
              _createElementVNode("div", _hoisted_13, [
                _hoisted_14,
                _createElementVNode("div", _hoisted_15, [
                  _createVNode(_component_font_awesome_icon, {
                    class: "icon-button",
                    size: "lg",
                    icon: "minus-circle",
                    onKeyup: _cache[4] || (_cache[4] = _withKeys(($event: any) => (_ctx.doAdjustSize(false)), ["enter"])),
                    onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.doAdjustSize(false))),
                    tabindex: "0"
                  }),
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    class: "scale-factor-input",
                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.scaleFactorDbText) = $event))
                  }, null, 512), [
                    [
                      _vModelText,
                      _ctx.scaleFactorDbText,
                      void 0,
                      { lazy: true }
                    ]
                  ]),
                  _createVNode(_component_font_awesome_icon, {
                    class: "icon-button",
                    size: "lg",
                    icon: "plus-circle",
                    onKeyup: _cache[7] || (_cache[7] = _withKeys(($event: any) => (_ctx.doAdjustSize(true)), ["enter"])),
                    onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.doAdjustSize(true))),
                    tabindex: "0"
                  })
                ])
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ], 32))
}